import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import userReducer from '../store/user/userSlice';
import infestReducer from '../store/infestation/infestSlice';
import clientReducer from '../store/client/clientSlice';
import productReducer from '../store/product/productSlice';
import mapsReducer from '../store/map/mapSlice';
import authReducer, { logoutUser } from '../store/auth/authSlice';
import projectReducer from '../store/project/projectSlice';

import { filtersApi } from '../services/api/cropLocation';
import { geojsonApi } from '../services/api/geojson';
import { clientApi } from '../services/api/client';
import { projectApi } from '../services/api/project';
import { infestationApi } from '../services/api/infestation';
import { cropApi } from '../services/api/crop';
import { cropVarietyApi } from '../services/api/cropVariety';
import { practiceCalendarApi } from '../services/api/practiceCalendar';
import { userApi } from '../services/api/user';
import { productApi } from '../services/api/product';
import { productRecommendationApi } from '../services/api/productRecommendation';
import { locationApi } from '../services/api/location';
import { soilTypeApi } from '../services/api/soilType';
import { feedbackApi } from '../services/api/feedback';
import { notificationApi } from '../services/api/notification';
import { cropStageApi } from '../services/api/cropStage';
import { infestationParametersApi } from '../services/api/infestationParameter';
import { analyticsApi } from '../services/api/analytics';
import { farmApi } from '../services/api/farm';
import { schemeApi } from '../services/api/scheme';
import { smsNotificationApi } from '../services/api/smsNotification';

const appReducer = combineReducers({
  user: userReducer,
  client: clientReducer,
  product: productReducer,
  maps: mapsReducer,
  auth: authReducer,
  infest: infestReducer,
  projectStateSlice: projectReducer,
  [filtersApi.reducerPath]: filtersApi.reducer,
  [geojsonApi.reducerPath]: geojsonApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [infestationApi.reducerPath]: infestationApi.reducer,
  [cropApi.reducerPath]: cropApi.reducer,
  [cropVarietyApi.reducerPath]: cropVarietyApi.reducer,
  [practiceCalendarApi.reducerPath]: practiceCalendarApi.reducer,
  [productRecommendationApi.reducerPath]: productRecommendationApi.reducer,
  [locationApi.reducerPath]: locationApi.reducer,
  [soilTypeApi.reducerPath]: soilTypeApi.reducer,
  [feedbackApi.reducerPath]: feedbackApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [cropStageApi.reducerPath]: cropStageApi.reducer,
  [infestationParametersApi.reducerPath]: infestationParametersApi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [farmApi.reducerPath]: farmApi.reducer,
  [schemeApi.reducerPath]: schemeApi.reducer,
  [smsNotificationApi.reducerPath]: smsNotificationApi.reducer,
});

// resets state on logout
const rootReducer = (state, action) => {
  if (action.type === logoutUser.type) {
    // clears all redux slices + RTK query cache
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(filtersApi.middleware)
      .concat(geojsonApi.middleware)
      .concat(clientApi.middleware)
      .concat(projectApi.middleware)
      .concat(userApi.middleware)
      .concat(cropApi.middleware)
      .concat(cropVarietyApi.middleware)
      .concat(practiceCalendarApi.middleware)
      .concat(infestationApi.middleware)
      .concat(productApi.middleware)
      .concat(productRecommendationApi.middleware)
      .concat(locationApi.middleware)
      .concat(soilTypeApi.middleware)
      .concat(feedbackApi.middleware)
      .concat(notificationApi.middleware)
      .concat(cropStageApi.middleware)
      .concat(infestationParametersApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(farmApi.middleware)
      .concat(schemeApi.middleware)
      .concat(smsNotificationApi.middleware),
});

setupListeners(store.dispatch);
